export default __webpack_public_path__ + "76aa4672e424175a56e10f181732eb86.png";